export default function Header({ title, count }) {
  return (
    <div className="flex w-[25%] border-b-2 border-solid border-slate-200 px-2 pb-2">
      <div className="w-[80%] text-sm font-medium">{title}</div>
      <div className="w-[20%] text-right text-sm">{"(" + count + ")"}</div>
    </div>
  );
}
